import { render, staticRenderFns } from "./RepositoryForm.vue?vue&type=template&id=f5fd7dfe&scoped=true"
import script from "./RepositoryForm.vue?vue&type=script&lang=js"
export * from "./RepositoryForm.vue?vue&type=script&lang=js"
import style0 from "./RepositoryForm.vue?vue&type=style&index=0&id=f5fd7dfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fd7dfe",
  null
  
)

export default component.exports